module.exports = __webpack_public_path__ + "img/earn_nav.20eb8897.png";